// extracted by mini-css-extract-plugin
export default {"l1":"loader_l1__GEA+S","hideshow":"loader_hideshow__O-h9q","l2":"loader_l2__bpELF","l3":"loader_l3__QRKSX","l4":"loader_l4__SB8LE","l5":"loader_l5__ayluN"};